export const isCustomized = (product: {custom?: boolean, isCustomized?: boolean}) => product.custom || product.isCustomized;